/**************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/

import _company from './_company.graphql';

import {
    categoryByUID,
    categoryList,
    productBySku,
    productSearch,
    storeConfig,
    productsByFilter,
    categoryWithChildrenByUID,
    categoryByFilterPagination,
    cockpitCategoryByParentIDPagination,
    cockpitCategoryByParentUIDPagination,
    cockpitCategoryWithProductsIDPagination,
    cockpitCategoryWithProductsUIDPagination,
    productWithVariants,
    productWithVariantProperties,
    _route,
    _productsByCategoryUID,
    _giftRegistry
} from '../2.4.3ee';

export {
    categoryByUID,
    categoryList,
    _productsByCategoryUID,
    productBySku,
    productSearch,
    storeConfig,
    productsByFilter,
    categoryWithChildrenByUID,
    categoryByFilterPagination,
    cockpitCategoryByParentIDPagination,
    cockpitCategoryByParentUIDPagination,
    cockpitCategoryWithProductsIDPagination,
    cockpitCategoryWithProductsUIDPagination,
    productWithVariants,
    productWithVariantProperties,
    _route,
    _giftRegistry,
    // company query got introduced in Adobe Commerce 2.4.4
    _company
};

export default {
    categoryByUID,
    categoryList,
    _productsByCategoryUID,
    productBySku,
    productSearch,
    storeConfig,
    productsByFilter,
    categoryWithChildrenByUID,
    categoryByFilterPagination,
    cockpitCategoryByParentIDPagination,
    cockpitCategoryByParentUIDPagination,
    cockpitCategoryWithProductsIDPagination,
    cockpitCategoryWithProductsUIDPagination,
    productWithVariants,
    productWithVariantProperties,
    _route,
    _giftRegistry,
    // company query got introduced in Adobe Commerce 2.4.4
    _company
};
